const mergetagDescriptions = {
  pe_key: {
    short: 'Unique user key',
    long: 'Unique key that identifies the user across the platform. Use it to match the same user between pages, pixels and integrations.',
  },
  action: { short: '', long: '' },
  address: { short: '', long: '' },
  address1: { short: '', long: '' },
  address2: { short: '', long: '' },
  age: { short: '', long: '' },
  allocation_id: { short: '', long: '' },
  bot_verification: { short: '', long: '' },
  browser: { short: '', long: '' },
  browseragent: { short: '', long: '' },
  campaignid: { short: '', long: '' },
  'capitalize()': { short: '', long: '' },
  city: { short: '', long: '' },
  completed: { short: '', long: '' },
  contestId: { short: '', long: '' },
  conversiontype: { short: '', long: '' },
  converted: { short: '', long: '' },
  cost: { short: '', long: '' },
  country: { short: '', long: '' },
  currentDate: { short: '', long: '' },
  currentDate_YYYYMMDD: { short: '', long: '' },
  date: { short: '', long: '' },
  device: { short: '', long: '' },
  dob: { short: '', long: '' },
  dob_dashes_mmddyyyy: { short: '', long: '' },
  dob_day: { short: '', long: '' },
  dob_dd: { short: '', long: '' },
  dob_mm: { short: '', long: '' },
  dob_month: { short: '', long: '' },
  dob_slashes_mmddyyyy: { short: '', long: '' },
  dob_year: { short: '', long: '' },
  dob_yyyy: { short: '', long: '' },
  dob_yyyyddmm: { short: '', long: '' },
  domain_url: { short: '', long: '' },
  duplicated: { short: '', long: '' },
  email: { short: '', long: '' },
  email_md5: { short: '', long: '' },
  email_verification: { short: '', long: '' },
  externalid: { short: '', long: '' },
  first_name: { short: '', long: '' },
  firstName: { short: '', long: '' },
  form_id: { short: '', long: '' },
  fraud_verification: { short: '', long: '' },
  fullConfirmationlURL: { short: '', long: '' },
  gender: { short: '', long: '' },
  impression_revenue: { short: '', long: '' },
  ip_city: { short: '', long: '' },
  ip_state: { short: '', long: '' },
  ip_zip: { short: '', long: '' },
  ipaddress: { short: '', long: '' },
  is_bot: { short: '', long: '' },
  last_name: { short: '', long: '' },
  last_registration: { short: '', long: '' },
  last_registration_dashes_mmddyyyy: { short: '', long: '' },
  last_registration_dashes_mmddyyyy_hhmmss: { short: '', long: '' },
  last_registration_dd: { short: '', long: '' },
  last_registration_mm: { short: '', long: '' },
  last_registration_slashes_mmddyyyy: { short: '', long: '' },
  last_registration_slashes_mmddyyyy_hhmmss: { short: '', long: '' },
  last_registration_yyyy: { short: '', long: '' },
  last_registration_yyyyddmm: { short: '', long: '' },
  last_registration_yyyyddmm_hhmmss: { short: '', long: '' },
  lastName: { short: '', long: '' },
  lastRegistration: { short: '', long: '' },
  leadid_cert: { short: '', long: '' },
  'lower()': { short: '', long: '' },
  'md5()': { short: '', long: '' },
  'multiply()': { short: '', long: '' },
  offer_id: { short: '', long: '' },
  optout: { short: '', long: '' },
  optoutdate: { short: '', long: '' },
  origin: { short: '', long: '' },
  os: { short: '', long: '' },
  page_id: { short: '', long: '' },
  path_id: { short: '', long: '' },
  path_page_id: { short: '', long: '' },
  path_session_uuid: { short: '', long: '' },
  path_slot_position: { short: '', long: '' },
  path_user_profile_id: { short: '', long: '' },
  payouttype: { short: '', long: '' },
  pe_key_new: { short: '', long: '' },
  peKey: { short: '', long: '' },
  phone: { short: '', long: '' },
  phone_areaCode: { short: '', long: '' },
  phone_prefix: { short: '', long: '' },
  phone_suffix: { short: '', long: '' },
  phone_verification: { short: '', long: '' },
  pid: { short: '', long: '' },
  post_id: { short: '', long: '' },
  post_target_id: { short: '', long: '' },
  postal_verification: { short: '', long: '' },
  publisher_id: { short: '', long: '' },
  referrer: { short: '', long: '' },
  registration_completed: { short: '', long: '' },
  registration_consent: { short: '', long: '' },
  registration_creation: { short: '', long: '' },
  registration_creation_dashes_mmddyyyy: { short: '', long: '' },
  registration_creation_dashes_mmddyyyy_hhmmss: { short: '', long: '' },
  registration_creation_dd: { short: '', long: '' },
  registration_creation_mm: { short: '', long: '' },
  registration_creation_slashes_mmddyyyy: { short: '', long: '' },
  registration_creation_slashes_mmddyyyy_hhmmss: { short: '', long: '' },
  registration_creation_yyyy: { short: '', long: '' },
  registration_creation_yyyyddmm: { short: '', long: '' },
  registration_creation_yyyyddmm_hhmmss: { short: '', long: '' },
  registration_date: { short: '', long: '' },
  registration_leadid: { short: '', long: '' },
  registration_trustedform: { short: '', long: '' },
  revenue_path_session_total: { short: '', long: '' },
  revenue_transaction_click_date: { short: '', long: '' },
  revenue_transaction_external_id: { short: '', long: '' },
  revenue_transaction_pekey: { short: '', long: '' },
  revenue_transaction_value: { short: '', long: '' },
  revenue_user_session_total: { short: '', long: '' },
  session_revenue: { short: '', long: '' },
  sessionid: { short: '', long: '' },
  sid1: { short: '', long: '' },
  sid2: { short: '', long: '' },
  sid3: { short: '', long: '' },
  site_id: { short: '', long: '' },
  siteDomain: { short: '', long: '' },
  siteId: { short: '', long: '' },
  siteName: { short: '', long: '' },
  slot_position: { short: '', long: '' },
  state: { short: '', long: '' },
  subscription_date: { short: '', long: '' },
  subscription_id: { short: '', long: '' },
  'sum()': { short: '', long: '' },
  sweepContestId: { short: '', long: '' },
  sweepId: { short: '', long: '' },
  sweepName: { short: '', long: '' },
  sweepTitle: { short: '', long: '' },
  tcpa_answer: { short: '', long: '' },
  tcpa_field: { short: '', long: '' },
  tcpa_isTCPA: { short: '', long: '' },
  tcpa_version: { short: '', long: '' },
  tcpaconsent: { short: '', long: '' },
  tcpaconsent_text: { short: '', long: '' },
  tcpaconsent_text_jsescape: { short: '', long: '' },
  test: { short: '', long: '' },
  ticket: { short: '', long: '' },
  timestamp: { short: '', long: '' },
  token: { short: '', long: '' },
  tokenTTL: { short: '', long: '' },
  trustedform_cert: { short: '', long: '' },
  'upper()': { short: '', long: '' },
  'url_param_value()': { short: '', long: '' },
  user_id: { short: '', long: '' },
  user_session_id: { short: '', long: '' },
  user_sweep_incent_claim_url: { short: '', long: '' },
  useragent: { short: '', long: '' },
  userId: { short: '', long: '' },
  userSessionId: { short: '', long: '' },
  usessionid: { short: '', long: '' },
  usid: { short: '', long: '' },
  zip: { short: '', long: '' },
}

export default mergetagDescriptions
